const baseUrl = "/baseapi";
export default {
  // 新闻
  getNewsList: `GET ${baseUrl}/news/newslist`,
  // 热门
  getHotNews: `GET ${baseUrl}/news/hot`,
  // 详情
  getNewsDetail: `GET ${baseUrl}/news/find`,
  // 新闻搜索条件列表
  getSelectAnnouncementList: `GET ${baseUrl}/news/title/list`,
  // 下一篇新闻
  getNextNew: `GET ${baseUrl}/news/next`,
  // 置顶
  getTopNews: `GET ${baseUrl}/news/top`,
  // 简报
  getBriefList: `GET ${baseUrl}/news/brief`,
  // 发展历程
  getHistoryList: `GET ${baseUrl}/about/history`,
  // 员工风采
  getStaffList: `GET ${baseUrl}/about/staff`,
  // 企业荣誉
  getHonorList: `GET ${baseUrl}/about/honorlist`,
  // 查询荣誉详情
  getHonorDeatail: `GET ${baseUrl}/about/honor/find`,
  // 论文报告
  getReportsList: `GET ${baseUrl}/academy/report`,
  // 技术成功--研究院 头部数据
  getAcdamyInfo: `GET ${baseUrl}/academy/get/1`,
  // // 获取主流媒体
  getMediaList: `GET ${baseUrl}/home/media`,
  //  获取banner
  getBannerList: `GET ${baseUrl}/home/banner`,
};
